import uib from 'angular-ui-bootstrap';

export default angular.module('eventix.common.services.scannerLoginModal',[uib])
    .factory('scannerLoginModal', function($uibModal) {
        /**
         * @param {ScannerType} scannerType The scanner type to show the login modal for
         * @return {function}
         */
        return function(scannerType) {
            return $uibModal.open({
                component: 'scannerLoginModal',
                resolve: {
                    scannerType: function() {
                        return scannerType;
                    }
                }
            }).result;
        };
    }).name;